
import React from "react";

const CustomLayout = ({ children }) => {
  return (
    <div className="custom-wrapper">
      {children}
    </div>
  );
};

export default CustomLayout;
